module.exports = __webpack_public_path__ + "static/media/old.00c6a127.png";